export const profileUserFormAreas = `
		"firstName logo"
		"lastName logo"
		"job logo"
		"email contactNumber"
		"fa fa"
		"password password"
		"submitButtons submitButtons"
		`;
